<template>
  <div class="env-page">
    <div style="width: 100%;background-color: #fff;">
      <nav-header @envchangedata="handlerdata"></nav-header>
    </div>

    <div class="main-content" :class="lang">
      <section class="section-card ">
        <div class="feature">
          <div class="section-header">
            <h2 class="title">
              {{ $t("env.carbonTargetTitle") }}<sup class="sup-idx">1</sup>
            </h2>
            <p class="desc-text">
              {{ $t("env.envtarget") }}<sup class="sup-idx1">2</sup>
              <span>{{ $t("env.symbol") }}</span>
            </p>
          </div>

          <div class="image-grid-layout">
            <div class="top-row">
              <div class="img-wrapper">
                <img src="../assets/env1.jpg" alt="" />
              </div>
              <div class="img-wrapper">
                <img src="../assets/envbusiness.jpg" alt="" />
              </div>
            </div>
          </div>
          <div class="footer-notes-notice">
            <p class="note-bold">{{ $t("env.carbonTargetstext1") }}</p>
            <p>1. {{ $t("env.carbonTargetstext2") }}</p>
            <p>
              2. {{ $t("env.carbonTargetstext3")
              }}<a
                href="https://sciencebasedtargets.org/target-dashboard"
                target="_blank"
                >（https://sciencebasedtargets.org/target-dashboard）</a
              >
            </p>
          </div>
        </div>

        <div class="sbt-promise-item feature sbt-promise-item-top">
          <h4 class="sub-title-green">{{ $t("env.envtargetTtile") }}</h4>
          <p class="body-text">
            {{
              lang === "zh"
                ? "SOHO中国承诺，以 2021 年为基准年，到 2030 年将公司拥有和租赁的建筑在运营过程中产生的范围1、范围2和范围3（涵盖已售产品的使用及下游租赁资产）的温室气体排放强度（每平方米）降低61.4%。同时，自2030年12月31日起，在其建筑资产组合中不再安装由公司拥有或财务控制的新的化石燃料设备。在同一时间框架内，将来自外购商品和服务的范围3温室气体绝对排放量减少42.0%。"
                : "SOHO China Limited commits to reduce scopes 1, 2 and 3 in-use operational GHG emissions of owned and leased buildings, covering use of sold products and downstream leased assets, 61.4% per m2 by 2030 from a 2021 base year. SOHO China commits to install no new fossil fuel equipment that are owned or financially controlled by the company in its buildings portfolios from December 31, 2030. SOHO China Limited also commits to reduce absolute scope 3 GHG emissions from purchased goods and services 42.0% within the same timeframe."
            }}
          </p>
        </div>

        <div class="sbt-promise-item middle feature">
          <h4 class="sub-title-green">{{ $t("env.envtargetTitle1") }}</h4>
          <p class="body-text">
            {{
              lang === "zh"
                ? "SOHO中国承诺，以 2021 年为基准年，到 2050 年将公司拥有和租赁的建筑在运营过程中产生的范围1、范围2和范围3（涵盖已售产品的使用及下游租赁资产）的温室气体排放强度（每平方米）降低98.2%。在同一时间框架内，将来自外购商品和服务以及燃料和能源相关活动的范围3温室气体绝对排放量减少90.0%。"
                : " SOHO China Limited commits to reduce scopes 1, 2 and 3 in-use operational GHG emissions of owned and leased buildings, covering use of sold products and downstream leased assets, 98.2% per m2 by 2050 from a 2021 base year. SOHO China Limited also commits to reduce absolute scope 3 GHG emissions from purchased goods and services and fuel- and energy-related activities 90.0% within the same timeframe."
            }}
          </p>
        </div>

        <div class="sbt-promise-item feature">
          <h4 class="sub-title-green">{{ $t("env.envtargetTitle2") }}</h4>
          <p class="body-text">
            {{
              lang === "zh"
                ? "SOHO中国承诺于2050年前实现全价值链的温室气体排放净零。"
                : " SOHO China Limited commits to achieve net-zero greenhouse gas emissions across the value chain by 2050."
            }}
          </p>
          <img src="../assets/env4.jpg" class="promise-img" />
        </div>
      </section>

      <!-- <section class="section-card feature">
  
       
      </section> -->

      <section class="section-card feature">
        <div class="section-header">
          <h2 class="title">
            {{
              lang === "zh"
                ? "减碳进展"
                : "SCIENCE-BASED TARGETS (SBT) PROGRESS"
            }}
          </h2>
          <p class="subtitle">{{ envcontent.achievementstime }}</p>
          <div class="card-text">
            <div v-if="lang === 'zh'">
              <p>
                运营阶段（范围1、范围2及范围3已售产品使用及下游租赁资产）的温室气体绝对排放量
              </p>
              <p>
                较基准年减少
                <strong class="card-text-bold">{{ envcontent.power }}</strong>
              </p>
              <p>来自外购商品及服务的温室气体绝对排放量</p>
              <p>
                较基准年减少
                <strong class="card-text-bold">{{ envcontent.ton }}</strong>
              </p>
              <p>来自燃料和能源相关活动的温室气体绝对排放量</p>
              <p>
                较基准年减少
                <strong class="card-text-bold">{{ envcontent.tree }}</strong>
              </p>
              <p>
                {{
                  envcontent.achievementstime
                }}年，SOHO中国未新安装任何由公司拥有或财务控制的化石燃料设备。
              </p>
            </div>
            <div v-else>
              <p>
                GHG emissions intensity per m2 during the building in-use
                operational phase (covering use of sold products and downstream
                leased assets) has been reduced by
              </p>
              <p>
                <strong class="card-text-bold">{{ envcontent.power }}</strong>
                from the base year.
              </p>
              <p>
                Absolute Scope 3 GHG emissions from purchased goods and services
                have been reduced by
              </p>
              <p>
                <strong class="card-text-bold">{{ envcontent.ton }}</strong>
                from the base year.
              </p>
              <p>
                Absolute Scope 3 GHG emissions from fuel- and energy-related
                activities have been reduced by
              </p>
              <p>
                <strong class="card-text-bold">{{ envcontent.tree }}</strong>
                from the base year.
              </p>
              <p style="text-align: left;">
                In {{ envcontent.achievementstime }}, SOHO China did not install
                any new fossil fuel equipment that is owned or financially
                controlled by the company.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="section-card feature">
        <div class="section-header">
          <h2 class="title">
            {{
              lang === "zh" ? "项目总能耗" : "TOTAL PROJECT ENERGY CONSUMPTION"
            }}<sup class="sup-idx">1</sup>
          </h2>
          <p class="subtitle">{{ envcontent.bythetime }}</p>
        </div>

        <div class="hero-stat">
          <span class="hero-label"
            >{{ envcontent.projectnum }}{{ $t("env.projectsmall") }}</span
          >
          <div class="value-group">
            <span class="num-large">{{ envcontent.totalsave }}</span
            ><span class="unit-text">{{ $t("env.pnum2") }}</span>
          </div>
        </div>

        <div class="stats-grid-bg">
          <div class="stat-item">
            <label>{{ $t("env.pleft") }}</label>
            <div class="value-group">
              <span class="num-sm">{{ envcontent.cumulativesave }}</span
              ><span class="unit-text-sm">{{ $t("env.pnum2") }}</span>
            </div>
          </div>
          <div class="stat-item">
            <label>{{ $t("env.pcenter") }}</label>
            <div class="value-group">
              <span class="num-sm">{{ envcontent.saverate }}</span
              ><span class="unit-sm">%</span>
            </div>
          </div>
          <div class="stat-item">
            <label>{{ $t("env.pright") }}</label>
            <div class="value-group">
              <span class="num-sm">{{ envcontent.reduceton }}</span>
              <span class="unit-k-sm" v-if="lang === 'en'">k</span>
              <span class="unit-text-sm">{{ $t("env.achnumContent") }}</span>
            </div>
          </div>
        </div>

        <div class="footer-notes">
          <p class="note-bold">{{ $t("env.carbonTargetstext1") }}</p>
          <p>1. {{ $t("env.consumeEneryTargetstext") }}</p>
        </div>
      </section>

      <section class="section-card feature">
        <div class="section-header">
          <h2 class="title">{{ $t("env.carbontitle") }}</h2>
          <p class="desc-p">{{ $t("env.carbonContent") }}</p>
        </div>
        <div class="swiper-container-wrap">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in childrenList" :key="index">
              <img :src="item.imgUrl" class="swiper-img" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </section>

      <section class="section-card feature">
        <div class="section-header">
          <h2 class="title">{{ $t("env.enerytitle") }}</h2>
          <p class="desc-p">{{ $t("env.enerycontent") }}</p>
        </div>
        <img src="/img/foundation/emery.jpg" class="full-img-rounded" />
      </section>

      <section class="section-card feature">
        <div class="section-header">
          <h2 class="title">{{ $t("env.greendev") }}</h2>
          <p class="desc-p">{{ $t("env.greencontent") }}</p>
        </div>
        <div class="highlight-data-box">
          <p class="h-label">
            {{
              lang === "zh"
                ? "主要投资物业组合获得绿色/健康认证的比例"
                : "The proportion of the primary investment property portfolio that has achieved green/healthy building certifications"
            }}
          </p>
          <span class="num-giant">100%</span>
        </div>
      </section>

      <section class="section-card dark-card feature">
        <div class="section-header">
          <h2 class="title-white">{{ $t("env.opentitle") }}</h2>
        </div>

        <p class="desc-white">{{ $t("env.opencontent") }}</p>
        <div class="highlight-data">
          <span class="h-label">{{ $t("env.opendetail") }}</span>
          <div class="h-value-wrap">
            <span class="h-num">100%</span>
            <span class="h-text" v-if="lang === 'zh'">平台化</span>
            <div v-else class="h-text-en">
              <span>Platform</span>
              <span>Management</span>
            </div>
          </div>
        </div>
      </section>

      <section class="section-card no-bg feature">
        <div class="section-header">
          <h2 class="title">{{ $t("env.honourtitle") }}</h2>
        </div>

        <div class="honour-summary">
          <p>{{ $t("env.honourhead") }}</p>
          <p>{{ $t("env.honourtext") }}</p>
          <div class="bonus-box">
            <span class="bonus-num">{{ envcontent.bonus }}</span>
            <span class="bonus-unit">{{ $t("env.honourunit") }}</span>
          </div>
        </div>

        <ul class="timeline">
          <li
            v-for="(item, index) in memorabiliaList"
            :key="index"
            class="timeline-item"
          >
            <div class="t-year">{{ item.date }}</div>
            <div class="t-info">{{ item.content }}</div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import NavHeader from "../components/Header";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
import { getdataInfo } from "../api/home";

export default {
  name: "Env",
  components: {
    NavHeader,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      id: 2,
      pageType: "env",
      envcontent: {},
      memorabiliaList: [],
      achievementstime: "",
      childrenList: [
        {
          id: "1",
          imgUrl: "https://sohochina.oss-cn-beijing.aliyuncs.com/ESG/lib1.jpg",
        },
        {
          id: "2",
          imgUrl: "https://sohochina.oss-cn-beijing.aliyuncs.com/ESG/lib2.jpg",
        },
        {
          id: "5",
          imgUrl: "https://sohochina.oss-cn-beijing.aliyuncs.com/ESG/lib3.jpg",
        },
        {
          id: "6",
          imgUrl: "https://sohochina.oss-cn-beijing.aliyuncs.com/ESG/lib4.jpg",
        },
        {
          id: "7",
          imgUrl: "https://sohochina.oss-cn-beijing.aliyuncs.com/ESG/lib5.jpg",
        },
      ],
      swiperOption: {
        loop: true,
        autoplay: { delay: 4000, disableOnInteraction: false },
        pagination: { el: ".swiper-pagination", clickable: true },
      },
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
    }),
  },
  mounted() {
    const revealing = {
      delay: 300,
      distance: "50px",
      duration: 600,
      easing: "cubic-bezier(0.5, 0, 0, 1)",
      origin: "bottom",
    };
    this.$scroll().reveal(".feature", { ...revealing, interval: 250 });
    this.getdata();
  },
  methods: {
    async getdata() {
      const data = await getdataInfo({ id: this.id, pageType: this.pageType });
      const zh_envdata = JSON.parse(data.esgContent.cnContent);
      const en_envdata = JSON.parse(data.esgContent.enContent);

      const currentData = this.lang === "zh" ? zh_envdata : en_envdata;
      this.envcontent = currentData;

      this.memorabiliaList = [...currentData.memorabiliaList].reverse();
    },
    handlerdata() {
      this.getdata();
    },
  },
};
</script>

<style scoped lang="scss">
$primary-green: #22c3ad;
$text-black: #353535;
$text-gray: #888888;
$font-condensed: "BarlowCondensed-bold";

.env-page {
  background-color: #f5f5f7;
  padding-bottom: 100px;
}

.main-content {
  max-width: 1086px;
  margin: 0 auto;
  padding: 60px 20px;
  .card-text {
    margin-top: 50px;
    p {
      font-size: 20px;
      line-height: 1.8;
      color: #353535;
      letter-spacing: 1px;
    }
    .card-text-bold {
      font-weight: bold;
      font-size: 30px;
    }
  }
  .section-card {
    background: #fff;
    border-radius: 30px;
    padding: 80px 60px;
    margin-bottom: 40px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.04);
    text-align: center;
    overflow: hidden;

    &.dark-card {
      background: $primary-green;
      color: #fff;
      box-shadow: none;
    }
    &.no-bg {
      background: transparent;
      box-shadow: none;
      padding: 60px 0;
    }
  }

  .section-header {
    margin-bottom: 50px;
    .title {
      font-size: 64px;
      color: $primary-green;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .title-white {
      font-size: 64px;
      color: #fff;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .subtitle {
      font-size: 48px;
      color: $text-black;
    }
    .desc-p,
    .desc-text {
      font-size: 20px;
      line-height: 1.8;
      color: $text-black;
      padding: 0 60px;
      text-align: justify;
    }
  }

  .image-grid-layout {
    margin: 40px 0;
    .top-row {
      display: flex;
      gap: 20px;
      margin-bottom: 20px;
      .img-wrapper {
        flex: 1;
        img {
          width: 100%;
          border-radius: 20px;
          display: block;
        }
      }
    }
    .bottom-row img {
      width: 100%;
      border-radius: 20px;
      display: block;
    }
  }

  .sbt-promise-item {
    text-align: left;
    padding: 0 40px;
    &.middle {
      margin: 60px 0;
      padding: 60px 40px;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
    }

    .sub-title-green {
      font-size: 28px;
      color: $primary-green;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .body-text {
      font-size: 18px;
      line-height: 1.8;
      color: $text-black;
      letter-spacing: 1px;
    }
    .promise-img {
      width: 100%;
      border-radius: 20px;
      margin-top: 30px;
    }
  }
  .sbt-promise-item-top {
    margin: 60px 0;
    padding: 60px 40px 0px 40px;
    border-top: 1px solid #eee;
  }

  .hero-stat {
    margin-bottom: 40px;
    .hero-label {
      font-size: 24px;
      color: $text-gray;
      display: block;
      margin-bottom: 10px;
    }
    .num-large {
      font-size: 110px;
      font-family: $font-condensed;
      color: $text-black;
    }
    .unit {
      font-size: 48px;
      margin-left: 10px;
      color: $text-black;
    }
    .unit-text {
      font-size: 32px;
      margin-left: 10px;
      color: $text-black;
    }
  }

  .stats-grid-bg {
    background: #fafafa;
    border-radius: 24px;
    padding: 50px;
    display: flex;
    justify-content: space-around;
    .stat-item {
      label {
        font-size: 20px;
        color: $text-gray;
        display: block;
        margin-bottom: 15px;
      }
      .num-sm {
        font-size: 64px;
        font-family: $font-condensed;
        color: $text-black;
      }
      .unit-sm {
        font-size: 28px;
        color: $text-black;
        margin-left: 5px;
      }
      .unit-text-sm {
        font-size: 20px;
        color: $text-gray;
        margin-left: 8px;
      }
    }
  }

  .swiper-container-wrap {
    margin-top: 40px;
    border-radius: 24px;
    overflow: hidden;
    .swiper-img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  /deep/ .swiper-pagination-bullet-active {
    background: $primary-green;
    width: 24px;
    border-radius: 4px;
  }

  .highlight-data-box {
    margin-top: 40px;
    padding: 40px;
    background: #f9fdfb;
    border-radius: 24px;
    .h-label {
      font-size: 20px;
      color: $text-gray;
      margin-bottom: 20px;
    }
    .num-giant {
      font-size: 130px;
      font-family: $font-condensed;
      color: $primary-green;
    }
  }

  .desc-white {
    font-size: 28px;
    opacity: 0.95;
    padding: 0 60px;
    line-height: 1.8;
    margin-bottom: 50px;
    text-align: left;
    color: #fff;
    letter-spacing: 1px;
  }
  .highlight-data {
    .h-label {
      font-size: 24px;
      color: #fff;
    }
    .h-value-wrap {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      margin-top: 20px;
      .h-num {
        font-size: 110px;
        font-family: $font-condensed;
      }
      .h-text {
        font-size: 40px;
        padding-bottom: 20px;
      }
      .h-text-en {
        text-align: left;
        font-size: 22px;
        line-height: 1.1;
        padding-bottom: 20px;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .honour-summary {
    p {
      font-size: 22px;
      color: $text-black;
      margin-bottom: 10px;
    }
    .bonus-box {
      margin: 40px 0;
      .bonus-num {
        font-size: 96px;
        font-family: $font-condensed;
        color: $text-black;
      }
      .bonus-unit {
        font-size: 40px;
        margin-left: 10px;
      }
    }
  }

  .timeline {
    max-width: 900px;
    margin: 60px auto 0;
    padding: 0;
    list-style: none;
    .timeline-item {
      display: flex;
      padding: 40px 0;
      border-bottom: 1px solid #e5e5e5;
      .t-year {
        font-size: 64px;
        font-family: $font-condensed;
        color: #ddd;
        min-width: 200px;
        text-align: left;
      }
      .t-info {
        font-size: 20px;
        line-height: 1.8;
        text-align: left;
        padding-left: 50px;
        flex: 1;
        color: $text-black;
      }
      &:hover .t-year {
        color: $primary-green;
        transition: 0.4s;
      }
    }
  }

  .full-img-rounded {
    width: 100%;
    border-radius: 24px;
    margin-top: 30px;
  }
  .sup-idx {
    font-size: 24px;
    vertical-align: super;
    margin-left: 4px;
  }
  .sup-idx1 {
    font-size: 16px;
    vertical-align: super;
    margin-left: 4px;
  }
  .footer-notes {
    margin-top: 60px;
    padding-top: 30px;
    border-top: 1px dashed #ddd;
    text-align: left;
    p {
      font-size: 15px;
      color: $text-gray;
      margin: 6px 0;
    }
    .note-bold {
      font-weight: bold;
      color: $text-black;
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
  .footer-notes-notice {
    margin-top: 20px;
    text-align: left;
    p {
      font-size: 15px;
      color: $text-gray;
      margin: 6px 0;
      padding: 0 60px;
    }
    .note-bold {
      font-weight: bold;
      color: $text-black;
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
}

.en {
  font-family: "Barlow-Regular", sans-serif;

  .title,
  .subtitle,
  .desc-p,
  .desc-text,
  .body-text,
  .sub-title-green,
  .desc-white,
  .h-label,
  .t-info {
    font-family: "Barlow-Regular", sans-serif;
  }
  .card-text p {
    font-family: "Barlow-Regular", sans-serif;
  }
  .section-header .title {
    font-size: 40px;
    line-height: 1.2;
  }
  .sub-title-green {
    font-size: 24px;
  }
}

@media (max-width: 680px) {
  .main-content {
    padding: 30px 15px;
    .section-card {
      padding: 40px 20px;
      border-radius: 20px;
    }
    .section-header .title,
    .section-header .title-white {
      font-size: 32px;
    }
    .section-header .subtitle {
      font-size: 24px;
    }
    .section-header .desc-p,
    .desc-text,
    .desc-white {
      padding: 0 20px;
      font-size: 16px;
    }
    .section-header .desc-text {
      padding: 0 20px;
    }
    .sbt-promise-item {
      padding: 0 20px;
    }
    .image-grid-layout .top-row {
      flex-direction: column;
    }
    .hero-stat .num-large {
      font-size: 60px;
    }
    .stats-grid-bg {
      flex-direction: column;
      gap: 30px;
      padding: 30px;
    }
    .num-giant {
      font-size: 80px !important;
    }
    .sbt-promise-item .body-text {
      font-size: 16px;
    }
    .footer-notes-notice {
      p {
        padding: 0 20px;
      }
    }
    .timeline .timeline-item {
      flex-direction: column;
      gap: 10px;
      .t-year {
        font-size: 40px;
        min-width: auto;
      }
      .t-info {
        padding-left: 0;
        font-size: 16px;
      }
    }
  }
}
</style>
